import styled from 'styled-components'
import Heading from '../../atoms/Heading/Heading'
import Text, { TextProps } from '../../atoms/Text/Text'
import colors from '../../theme/colors'

export const CardContentSection = styled.section`
  padding-left: 24px;
  padding-right: 24px;
`

export const CardContent = styled.article`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;

  ${CardContentSection} {
    &:first-of-type {
      padding-top: 24px;
    }
    &:last-of-type {
      padding-bottom: 24px;
    }
  }
`

export const StyledHeading = styled(Heading)`
  margin-bottom: 24px;
`

const DefaultDescriptionProps: TextProps =  {
  size: 'medium',
  light: true,
}

export const Description = styled(Text).attrs(DefaultDescriptionProps)`
  margin-bottom: 12px;
`

export const Cost = styled(Text).attrs({
  size: 'large',
})`
  margin-bottom: 12px;
`

export const Divider = styled.hr`
  margin-top: 0;
  margin-bottom: 16px;
  color: ${colors.Primary.Grey};
`
